import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import { axiosErrorHandler, toast_request_error } from '@acri-tools/react-tools/utils/global';
import { API_URL } from '../../utils/config';
import request from '@acri-tools/react-tools/utils/request';
import { create_toast } from '@acri-tools/react-tools/utils/toasts';
import classNames from 'classnames';
import React,{Component} from 'react';
import DocumentForm from '../DocumentForm/DocumentForm';

import './UpdateDocument.css';

interface Props{
    document: any

    onUpdate?: Function
}
interface State{
    updating: boolean

    // updates 
    updates: any
}


export default class UpdateDocument extends Component<Props,State>{
    constructor(props:Props){
        super(props);
        this.state = {
            updating: false,
            updates:{}
        }
    }

    componentDidUpdate(prevProps:any){
        if(this.props.document !== prevProps.document){
            this.setState({ updates: {} })
        }
    }
    
    render(){
        return (
            <div className="update-document">
                {/* <Optional>*Required</Optional> */}
                {/* <br/>
                <br/> */}

                <DocumentForm
                    updates={this.state.updates}
                    document={this.props.document}
                    onChange={(updates:any)=>{
                        this.setState({
                            updates: {
                                ...this.state.updates,
                                ...updates
                            }
                        });
                    }}
                />

                <br/>
                <br/>
                <div className="centered">
                    <div 
                        className={classNames({
                            "custom-button blue inline medium": true,
                            "disabled": this.state.updating
                        })}
                        onClick={this.update}
                    >
                        {
                            this.state.updating ? 
                            <Spinner height={15} white/>:
                            <><i className="fas fa-pen"/> UPDATE DOCUMENT</>
                        }

                    </div>
                </div>
            </div>
        );
    }


    update = async() =>{
        let { updates } = this.state;

        var body = new FormData();
        
        for(let attr of Object.keys(updates)){
            if(attr === "category_group") continue;
            if(updates.file) body.append('file', updates.file);
            else if(updates[attr]) body.append(attr, updates[attr]);
        }

        this.setState({ updating: true })
        try{
            let res = await request(`${API_URL}/api/v1/documents/${this.props.document.id}`,{
                method:'put',
                data: body
            })

            this.props.onUpdate?.();

            create_toast({ type: 'success', message: `Successfully updated document ${res.data.value.name}` })

            // console.log("this.state", this.state);
        }
        catch(e:any){
            axiosErrorHandler( e, { 
                functionName: 'update'
            })
            toast_request_error(e);
        }
        finally{
            this.setState({ updating: false })
        }
    }
};